import React from "react";

export default function StatCard(props: {
  title: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  right?: React.ReactNode;
}) {
  return (
    <div className="rounded-xl border bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs text-gray-500">{props.title}</div>
          <div className="mt-1 text-2xl font-semibold">{props.value}</div>
          {props.sub ? <div className="mt-1 text-xs text-gray-500">{props.sub}</div> : null}
        </div>
        {props.right ? <div>{props.right}</div> : null}
      </div>
    </div>
  );
}